/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as C from "react";
import { GridContext as c } from "../../GridClientWrapper.mjs";
import { GridHeaderRowContext as a } from "./GridHeaderRowContainer.mjs";
import { cloneReactElement as u } from "../../utils/index.mjs";
const f = (e) => {
  const n = C.useContext(c), t = C.useContext(a), i = n.isClient || e.isClient, r = {
    style: { ...n.getCellPositionStyle(e.column) }
  }, s = {
    onKeyDown: (l) => {
      t.cellKeyDown(l, e.column);
    }
  };
  let o = {
    onClick: (l) => {
      t.cellClick(l, e.column);
    }
  };
  return i && (o = {
    ...o,
    render: e.render,
    selectionChange: n.onHeaderSelectionChange,
    columnMenuWrapperProps: {
      ...e.columnMenuWrapperProps,
      onSortChange: n.sortChange,
      onFilterChange: n.filterChange,
      onGroupChange: n.groupChange,
      onColumnsStateChange: n.onColumnsStateChange,
      show: t.showColumnMenuField === e.column.field ? !0 : void 0,
      onCloseMenu: t.handleCloseMenu,
      columnsState: n.columnsState
    }
  }), e.isCustom && (i ? o = {
    ...o,
    thProps: {
      ...e.thProps,
      ...s,
      ...r
    }
  } : o = {
    ...o,
    ...s,
    ...r
  }), u(e.children, {
    ...o
  });
};
export {
  f as GridHeaderCellContainer
};
